import React from "react";
import InstagramSosmed from "./InstagramSosmed";

const InstagramMain = () => {
  return (
    <section id="instagram" className="pt-12">
      <div className="">
        <InstagramSosmed />
      </div>
    </section>
  );
};

export default InstagramMain;
